import { useSyncExternalStore } from 'react'
import { IconAlert, IconCheck } from './icons.tsx'

// Снекбар без провайдера: модуль-хранилище, чтобы показывать его из мутаций React Query.

export interface SnackOptions {
  text: string
  tone?: 'default' | 'success' | 'error'
  action?: { label: string; onClick: () => void }
  duration?: number
}

interface Snack extends SnackOptions {
  id: number
}

let current: Snack | null = null
let timer: ReturnType<typeof setTimeout> | undefined
let seq = 0
const listeners = new Set<() => void>()

function emit(): void {
  for (const l of listeners) l()
}

function hide(): void {
  clearTimeout(timer)
  current = null
  emit()
}

function show(opts: SnackOptions): void {
  clearTimeout(timer)
  seq += 1
  current = { ...opts, id: seq }
  emit()
  timer = setTimeout(hide, opts.duration ?? (opts.action ? 5000 : opts.tone === 'error' ? 5000 : 3200))
}

export const snackbar = {
  show,
  hide,
  success(text: string, action?: SnackOptions['action']): void {
    show({ text, tone: 'success', action })
  },
  error(text: string): void {
    show({ text, tone: 'error' })
  },
}

export function useSnackbar(): typeof snackbar {
  return snackbar
}

function subscribe(fn: () => void): () => void {
  listeners.add(fn)
  return () => listeners.delete(fn)
}

function getSnapshot(): Snack | null {
  return current
}

export function SnackbarHost() {
  const snack = useSyncExternalStore(subscribe, getSnapshot, getSnapshot)
  return (
    <div className="snackbar-host" role="status" aria-live="polite">
      {snack && (
        <div key={snack.id} className={`snackbar snackbar--${snack.tone ?? 'default'}`}>
          {snack.tone === 'success' && (
            <span className="snackbar__icon">
              <IconCheck size={20} />
            </span>
          )}
          {snack.tone === 'error' && (
            <span className="snackbar__icon">
              <IconAlert size={20} />
            </span>
          )}
          <span className="snackbar__text">{snack.text}</span>
          {snack.action && (
            <button
              type="button"
              className="snackbar__action"
              onClick={() => {
                snack.action?.onClick()
                hide()
              }}
            >
              {snack.action.label}
            </button>
          )}
        </div>
      )}
    </div>
  )
}
